import React from 'react';
import i18n from '../data/Lang';
import './Alert.css';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const showError = (message) => {
     const marathi = i18n.language?.startsWith('mr');
     const text = typeof message === 'string' && message.trim()
          ? message : (marathi ? 'कृपया पुन्हा प्रयत्न करा.' : 'Please try again.');
     return toast.error(
          <div className="nd-error-content">
               <span className="nd-error-title">{marathi ? 'काहीतरी चुकले' : 'Something went wrong'}</span>
               <span className="nd-error-message">{text}</span>
          </div>,
          {
               theme: 'light',
               className: 'nd-error-toast',
               bodyClassName: 'nd-error-body',
               progressClassName: 'nd-error-progress',
               position: 'top-right',
               autoClose: 6000,
               closeOnClick: false,
               pauseOnHover: true,
               pauseOnFocusLoss: true,
               draggable: false,
               role: 'alert',
               toastId: `error:${text}`,
               icon: <span className="nd-error-icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none"><path d="M12 8v5m0 3h.01" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/><path d="M10.3 3.9 2.8 17a2 2 0 0 0 1.7 3h15a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round"/></svg></span>,
               closeButton: ({closeToast}) => <button type="button" className="nd-error-close" onClick={closeToast} aria-label={marathi ? 'सूचना बंद करा' : 'Dismiss error'}><svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="m6 6 8 8M14 6l-8 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg></button>,
          }
     );
};

const Alert = {
     success: (message) => toast.success(message, { theme: 'colored' }),
     failure: showError,
     error: showError,
     warning: (message) => toast.warning(message, { theme: 'colored' }),
     info: (message) => toast.info(message, { theme: 'colored' }),
};

export default Alert;
